module.exports = __webpack_public_path__ + "img/downloadFill.3f60a6cc.svg";